import { render } from "./Videos.vue?vue&type=template&id=25d71ca8&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=25d71ca8&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d71ca8"]])

export default __exports__